import { useMutation } from "@tanstack/react-query";
import { UpdatePermissionForm } from "../schema/UpdatePermissionSchema";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../response/ValidationErrorResponse";
import { PermissionResponseSchema } from "../response/PermissionResponse";

export const useUpdatePermission = () => {
    return useMutation({
        mutationFn: async (values: {
            permissionId: number;
            formData: UpdatePermissionForm;
        }) => privateApi.put(`/v3/permission/${values.permissionId}`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = PermissionResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid permission data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update permission', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid permission data format");
            } else {
                console.error('Failed to update permission', error);
                throw error;
            }
        },
    });
};